import React, { FC, useState } from "react";
import { Collapse, Checkbox, Input, Radio, Tooltip, InputNumber } from "antd";

import "./filters.scss";
import "../../style/main.scss";
import Criteria from "./criteria";
import { TFiltersProps, TFilterOption } from "./constant";
import { RightOutlined } from "@ant-design/icons";
import { cloneDeep, get, map } from "lodash";
import classNames from "classnames";

const { Panel } = Collapse;

const Filters: FC<TFiltersProps> = ({ data, changeHandler }: TFiltersProps) => {
  const [dataState, setDataState] = useState(cloneDeep(data));
  return (
    <div className="drawerFiltersWrapper">
      <Collapse
        defaultActiveKey={["1"]}
        expandIconPosition={"right"}
        expandIcon={({ isActive }) => (
          // <DownOutlined
          //   rotate={isActive ? -180 : 0}
          //   style={{ fontSize: "14px", color: "#42526e" }}
          // />
          <RightOutlined style={{ fontSize: "14px", color: "#42526e" }}/>
        )}
      >
        {dataState?.map((item: TFilterOption, idx: number) => {
          const { filterName, filterValues, filterType } = item;

          let filteredOptionValues = cloneDeep(
            get(data[idx], "filterValues", []) !== null
              ? get(data[idx], "filterValues", [])
              : []
          );

          const onChangeFilter = (e: any) => {
            filteredOptionValues = cloneDeep(
              get(data[idx], "filterValues", []) !== null
                ? get(data[idx], "filterValues", [])
                : []
            );
            let inputSearch = e.target.value;
            filteredOptionValues = filteredOptionValues.filter(
              (obj: any) =>
                obj.label.toLowerCase().includes(inputSearch.toLowerCase()) ||
                data[idx]["selectedOptions"]?.includes(obj.label)
            );
            let locals = [...dataState];
            locals[idx].filterValues = filteredOptionValues;
            setDataState(locals);
          };

          /**
           * this is responsible to reorder the list of options depending upon the selected ones.
           */

          let filterValues1 = filterValues?.filter((el) =>
            data[idx]["selectedOptions"]?.includes(el.label)
          );

          let finalFilteredValue = filterValues1?.concat(
            filterValues?.filter(
              (el) => !data[idx]["selectedOptions"]?.includes(el.label)
            )
          );

          const selectedOptionsOfActiveIndex = cloneDeep(
            get(data[idx], "selectedOptions", [])
          );

          switch (filterType) {
            // if filter type is checkbox then draw checkbox
            case "checkbox":
              return (
                <Panel
                  header={filterName}
                  key={filterName}
                  className={`filtersPanel`}
                >
                  {data[idx]?.filterValues?.length > 5 ? (
                    <Input
                      onChange={onChangeFilter}
                      allowClear={true}
                      className="inputForSearchFilter"
                      placeholder={`Search ${filterName
                        .split(" ")
                        .map(
                          (str) =>
                            str.charAt(0).toUpperCase() +
                            str.slice(1).toLowerCase()
                        )
                        .join(" ")}`}
                    />
                  ) : null}

                  <Checkbox.Group
                    name={filterName}
                    options={finalFilteredValue}
                    value={data[idx]["selectedOptions"]}
                    onChange={(selectedArray) =>
                      changeHandler(idx, selectedArray)
                    }
                    className={`${
                      filterValues?.length > 5
                        ? "panelWithMoreOption custom-scroll-bar"
                        : ""
                    }`}
                  />
                </Panel>
              );
            case "radio":
              // if filter type is radio then draw radio group
              return (
                <div className="drawerFiltersWrapper__radio" key={filterName}>
                  <div className="drawerFiltersWrapper__radio__header">
                    {filterName}
                  </div>
                  <Radio.Group
                   defaultValue={"NA"}
                    onChange={(e) => changeHandler(idx, e.target.value)}
                    value={data[idx]["selectedOptions"]}
                  >
                    {map(filterValues, (option: any) => {
                      const classNameForRadio = classNames({
                        notApplicable: option.value === "NA",
                        green: option.value === "G",
                        yellow: option.value === "Y",
                        red: option.value === "R",  
                      });
                      const tooltipLabel =
                        option.value === "NA" ? (
                          <span>
                            Not Applicable
                          </span>
                        ) : option.value === "G" ? (
                          <span>
                            41-100% population<br></br>with high risk scores 
                          </span>
                        ) : option.value === "Y" ? (
                          <span>
                            21-40% population<br></br>with high risk scores
                          </span>
                        ) : option.value === "R" ? (
                          <span>
                           Top 20% population<br></br>with high risk scores
                          </span>
                        ) :(
                          <span></span>
                        );

                      return (
                        <Tooltip
                          key={option.value}
                          title={
                            <>
                              <div
                                className={`dot dot--${classNameForRadio}`}
                              ></div>
                              {tooltipLabel}
                            </>
                          }
                        >
                          <Radio
                            value={option.value}
                            className={classNameForRadio}
                          ></Radio>
                        </Tooltip>
                      );
                    })}
                  </Radio.Group>
                </div>
              );
            case "range":
              // if filter type is range then draw from and to input
              return (
                <div className="drawerFiltersWrapper__radio" key={filterName}>
                  <div className="drawerFiltersWrapper__radio__header">
                    {filterName}
                  </div>
                  <InputNumber
                    // formatter={(value) =>
                    //   `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    // }
                    // parser={(displayValue: any) =>
                    //   displayValue?.replace(/\$\s?|(,*)/g, "")
                    // }
                    placeholder="0.000"
                    onChange={(value) => {
                      selectedOptionsOfActiveIndex[0] = value;
                      changeHandler(idx, selectedOptionsOfActiveIndex);
                    }}
                    value={data[idx]["selectedOptions"]?.[0]}
                  />
                  to
                  <InputNumber
                    // formatter={(value) =>
                    //   `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    // }
                    // parser={(displayValue: any) =>
                    //   displayValue?.replace(/\$\s?|(,*)/g, "")
                    // }
                    placeholder="0.000"
                    value={data[idx]["selectedOptions"]?.[1]}
                    onChange={(value) => {
                      selectedOptionsOfActiveIndex[1] = value;
                      changeHandler(idx, selectedOptionsOfActiveIndex );
                    }}
                  />
                </div>
              );
            case "criteria":
              return (
                <Panel
                  header={filterName}
                  key={filterName}
                  className={`filtersPanel`}
                >
                  <Criteria
                    idx={idx}
                    changeHandler={changeHandler}
                    selectedValue={get(data[idx], "selectedOptions", [{}])}
                  />
                </Panel>
              );
            default:
              return null;
          }
        })}
      </Collapse>
    </div>
  );
};

export default Filters;
